export const TIPOS_DOCUMENTO = [
  { value: '33', codigo: 33, label: 'Factura Electrónica' },
  { value: '39', codigo: 39, label: 'Boleta Electrónica' },
  { value: '41', codigo: 41, label: 'Boleta Exenta Electrónica' },
];

export const labelTipoDocumento = (codigo) => {
  const tipo = TIPOS_DOCUMENTO.find((t) => String(t.codigo) === String(codigo));
  return tipo ? tipo.label : codigo;
};

export const tiposDisponiblesEmpresa = (empresas, extraFilter) => {
  const habilitados =
    Array.isArray(empresas) && Array.isArray(empresas[0]?.tiposdocumento)
      ? empresas[0].tiposdocumento
      : null;

  return TIPOS_DOCUMENTO.filter((t) => {
    if (habilitados && !habilitados.includes(t.codigo)) return false;
    if (extraFilter && !extraFilter(t)) return false;
    return true;
  });
};
